<ngx-select
    [noAutoComplete]="false"
    [allowClear]="false"
    [multiple]="false"
    (select)="onChange($event)"
    [items]="providerShops"
    [(ngModel)]="selectedProviderShopID"
></ngx-select>
